import type { ReactNode } from "react"
import { useCallback, useState } from "react"
import { useCreation } from "ahooks-v2"
import { Auth } from "./auth"
import { AuthContext } from "./AuthContext"
import cookies from "@/util/cookies"
import {
  COOKIE_DOMAIN,
  TokenKey,
  ExpiresInKey,
  SystemAuthKey,
  NHTokenKey,
} from "@/constants/config"
import useUserModel from "@/models/useUserModel"

function AuthProvider({ children }: { children: ReactNode }) {
  const { updateUser } = useUserModel()
  const [user, setUser] = useState<any>(() => {
    // initial user info
    const user = cookies.parsedCookies()
    return user
  })

  const writeCookies = useCallback((user: any) => {
    user[SystemAuthKey] = user[SystemAuthKey] ? "1" : "0"
    // 将用户信息写入cookie
    if (user && (user[TokenKey] || user[NHTokenKey])) {
      Object.keys(user).forEach((sKey) => {
        cookies.setItem(sKey, user[sKey], "/", user[ExpiresInKey], COOKIE_DOMAIN)
      })
    }
  }, [])

  const clearCookies = useCallback((user) => {
    if (user) {
      Object.keys(user).forEach((sKey) => {
        cookies.removeItem(sKey, "/", COOKIE_DOMAIN)
      })
    }
  }, [])

  const signin = useCallback((newUser: any, callback: VoidFunction) => {
    return Auth.signin(() => {
      writeCookies(newUser)
      updateUser(newUser)
      setUser(newUser)
      callback()
    })
    // eslint-disable-next-line
  }, [])

  const signout = useCallback((callback: VoidFunction) => {
    return Auth.signout(() => {
      setUser((prevUser: any) => {
        clearCookies(prevUser)
        return null
      })
      callback()
    })
    // eslint-disable-next-line
  }, [])

  const value = useCreation(() => ({ user, signin, signout }), [user, signin, signout])

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export default AuthProvider
